export default __webpack_public_path__ + "static/media/rear.96750037.png";